export enum XmlImportSeverityTypes {
    All = 'All',
    Error = 'Error',
    Warning = 'Warning',
    Info = 'Info'
}
